import { ErrorComponent, type ErrorComponentProps } from '@tanstack/react-router';
import { AccessDenied } from '@/components/custom/access-denied';
import { isForbiddenError } from '@/lib/http-errors';

/**
 * The router's default error boundary. A permission denial gets the
 * access-denied screen; everything else keeps the library's own error
 * rendering, so this narrows the 403 case without swallowing real faults.
 */
export function RouteErrorComponent({ error, ...props }: ErrorComponentProps) {
  if (isForbiddenError(error)) {
    return <AccessDenied />;
  }
  return <ErrorComponent error={error} {...props} />;
}
